module.exports = __webpack_public_path__ + "static/word-green.48fb5076.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/word-green.png
// module id = 991
// module chunks = 2